import { PaySpan, DPEmployeePayment } from "Shared/types/Payments";

export default function createPaySpan(
  payment: DPEmployeePayment
): PaySpan | null {
  if (!payment.relatedPayments) return null;

  return {
    thisAmount: payment.payPeriodAmountCents,
    prevAmount: payment.relatedPayments.previousPayPeriodAmountCents,
    nextAmount: payment.relatedPayments.nextPayPeriodAmountCents,
    otherAmount: payment.relatedPayments.otherTransferAmountCents,
    totalAmount:
      payment.payPeriodAmountCents +
      payment.relatedPayments.previousPayPeriodAmountCents +
      payment.relatedPayments.nextPayPeriodAmountCents +
      payment.relatedPayments.otherTransferAmountCents,
  };
}
